import { NotFoundError } from "./KazooError";

/**
 * Type representing something that might be a not found error.
 */
export type PossibleNotFoundError =
  | Error
  | NotFoundError
  | { message: string; extensions: { exception: { code: string } } }
  | {
      message: string;
      extensions: { code: string }; // this seems wrong, but our inter-api GQL calls seem to return this shape.
    };

/**
 * Returns true if the error is caused by something being not found, either direct from the db or via GQL.
 * @param error
 * @returns true if the error is caused by something being not found/
 */
export function isDbOrGQLNotFoundError(error: PossibleNotFoundError) {
  if (error instanceof NotFoundError) {
    return true;
  }
  if (isGQLNotFoundError(error)) {
    return true;
  }

  if (error.message?.match(/not found/i)) {
    return true;
  }
  return false;
}

function isGQLNotFoundError(error: PossibleNotFoundError) {
  if ("extensions" in error) {
    if ("code" in error.extensions && error.extensions.code === "NOT_FOUND") {
      return true;
    }
    if (
      "exception" in error.extensions &&
      error.extensions.exception.code === "NOT_FOUND"
    ) {
      return true;
    }
  }
  return false;
}
